import { getClassNames } from '@websolutespa/bom-core';
import { useLabel } from '@websolutespa/bom-mixer-hooks';
import { IconLlmArrowUp } from '@websolutespa/bom-mixer-icons';
import { useLlm } from '../../../useLlm/useLlm';
import { useLlmView } from '../../../useLlm/useLlmView';
import style from './page-submit.module.scss';

export const PageSubmit: React.FC = () => {
  const label = useLabel();
  const {
    Blob,
  } = useLlm(state => state.components);
  const streaming = useLlm(state => state.streaming);
  const prompt = useLlm(state => state.prompt);
  const { clear } = useLlm(state => state.actions);
  const { send } = useLlmView(state => state.actions);

  const onSubmit = async (event?: React.FormEvent) => {
    event && event.preventDefault();
    if (!prompt) {
      return;
    }
    clear();
    await send(prompt, (response) => {
      // console.log('PagePrompt.onChunk', response.chunks);
    }, (response) => {
      // console.log('PagePrompt.onEnd', response);
    });
  };

  return (
    <button type="submit" className={getClassNames(style.submit)}
      disabled={!prompt || streaming}
      aria-label={label('llm.sendPrompt')}
      onClick={onSubmit}
    >
      <IconLlmArrowUp />
    </button>
  );
};
